import { Suspense, lazy } from 'react';
import { cn } from '@/app/lib';
import { Spinner } from '@workspace/ui/common';

// Lazy Load components on demand
const ChatHeader = lazy(() => import('./ChatHeader'));
const ChatMessagesList = lazy(() => import('./ChatMessagesList'));
const ChatInputForm = lazy(() => import('./ChatInputForm'));

interface ChatWindowProps {
  logoUrl: string;
  onClose: () => void;
  showDisclaimer: boolean;
  onDismissDisclaimer: () => void;
}

function ComponentLoadingFallback() {
  return (
    <div className="flex items-center justify-center h-20">
      <Spinner className="text-primary" />
    </div>
  );
}

export default function ChatWindow({ logoUrl, onClose, showDisclaimer, onDismissDisclaimer }: ChatWindowProps) {
  return (
    <div
      className={cn(`
        w-94 max-w-full h-[765px] max-h-[85vh] md:max-h-[98vh]
        fixed bottom-0 md:right-30
        z-1001 overflow-hidden
        bg-white rounded-t-2xl shadow-lg
        flex flex-col
      `)}
    >
      <Suspense fallback={<ComponentLoadingFallback />}>
        <ChatHeader logoUrl={logoUrl} onClose={onClose} />
        <ChatMessagesList />
        <ChatInputForm showDisclaimer={showDisclaimer} onDismissDisclaimer={onDismissDisclaimer} />
      </Suspense>
    </div>
  );
}
